// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.carousel-img {
  width: 200px;      /* smaller image width */
  height: 180px;     /* smaller image height */
  object-fit: cover;
  margin: 0 32px;    /* gap between image and arrows */
  border-radius: 8px;
}

.carousel-control-prev,
.carousel-control-next {
  width: 40px;       /* make arrows more prominent */
  opacity: 1;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-size: 2rem 2rem;
  filter: drop-shadow(0 0 2px #000);
}`, "",{"version":3,"sources":["webpack://./src/components/Carousel/CarouselComponent.css"],"names":[],"mappings":";AACA;EACE,YAAY,OAAO,wBAAwB;EAC3C,aAAa,MAAM,yBAAyB;EAC5C,iBAAiB;EACjB,cAAc,KAAK,iCAAiC;EACpD,kBAAkB;AACpB;;AAEA;;EAEE,WAAW,QAAQ,+BAA+B;EAClD,UAAU;AACZ;;AAEA;;EAEE,0BAA0B;EAC1B,iCAAiC;AACnC","sourcesContent":["\n.carousel-img {\n  width: 200px;      /* smaller image width */\n  height: 180px;     /* smaller image height */\n  object-fit: cover;\n  margin: 0 32px;    /* gap between image and arrows */\n  border-radius: 8px;\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  width: 40px;       /* make arrows more prominent */\n  opacity: 1;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  background-size: 2rem 2rem;\n  filter: drop-shadow(0 0 2px #000);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
